import React, { Component } from "react";
import Image from '../global/Image';

export default class PageTeamMember extends Component {
	
	constructor(props) {
		super(props)
		this.onIntersection = this.onIntersection.bind(this)
		this.state = {
			inView: false,
		}
	}

	componentDidMount() {
		if (this.$box) {
			let loadObserver;
			let options = {
				root: null,
				rootMargin: "-20% 0px -20% 0px",
				threshold: 0
			};
			let observer = new IntersectionObserver(this.onIntersection, options);
			observer.observe(this.$box);
		}
	}

	onIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.inView === false) {
				this.setState({ inView: true });
			}						
		});
	} 
  	
	render () {
		
		let item = this.props.item;
		let index = this.props.index;
				
		if (item) {
						
		    return (
			    
			    <>
			    
			    	<div className={'c-team__hr c-team__hr--s-' + index % 2 + ' c-team__hr--m-' + index % 3 + ' c-team__hr--l-' + index % 4 + ' ' + (this.state.inView ? "state-in-view" : "")}>
			    		<div className="c-team__hr__inner"></div>
			    	</div>
			    
				    <div className={'c-team__item ' + (this.state.inView ? "state-in-view" : "")} ref={(box) => { this.$box = box; }}>
				    
						<div className="c-team__item__inner">
							<div className="c-team__item__image">
								<Image srcset={item.srcset} src={item.src} />
							</div>
							<div className="c-team__item__text">
								<h3 className="c-team__item__name" dangerouslySetInnerHTML={ {__html: item.name}}></h3>
								<h4 className="c-team__item__role" dangerouslySetInnerHTML={ {__html: item.role}}></h4>
							</div>
						</div>
				    			    													    
				    </div>
				    
				</>
			)
			
		} else {
			
			return null;
		
		}
	}
}
